// General utility functions - language agnostic or configurable

/**
 * Generate a new unique ID with a prefix and random string
 */
export function generateId(prefix = 'id'): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

/**
 * Generate new IDs for objects in an array that have an 'id' property
 */
export function regenerateIds<T extends { id: string }>(items: T[], idPrefix?: string): T[] {
  return items.map(item => ({
    ...item,
    id: generateId(idPrefix)
  }));
}

export function formatCurrency(amount: number, locale = 'de-DE') {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
  }).format(amount);
}

export function formatDate(date: string | Date, locale = 'de-DE') {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (!dateObj || isNaN(dateObj.getTime())) return 'N/A';
  
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(dateObj);
}

export function formatDateTime(date: string | Date, locale = 'de-DE') {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (!dateObj || isNaN(dateObj.getTime())) return 'N/A';
  
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(dateObj);
}
